import React from "react";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "react-quill/dist/quill.snow.css";

import useScrollToTop from "../../../../hooks/useScrollToTop";

import useSettingsManager from "./hooks/useSettingsManager";

import SettingsHeader from "./components/SettingsHeader";
import SettingsStats from "./components/SettingsStats";
import SettingsForm from "./components/SettingsForm";
import SettingsPreviewPanel from "./components/SettingsPreviewPanel";

export default function ParametresClub() {
  useScrollToTop();

  const {
    settings,
    galleries,
    loading,
    saving,
    demoMode,
    stats,

    handleChange,
    updateField,
    handleSubmit,
    refreshData,
  } = useSettingsManager();

  return (
    <section className="w-full pb-10 font-satoshi">
      <div className="mx-auto max-w-[1500px] space-y-5">
        <SettingsHeader
          loading={loading}
          saving={saving}
          demoMode={demoMode}
          onRefresh={refreshData}
          onSave={handleSubmit}
        />

        <SettingsStats stats={stats} />

        <div className="grid gap-5 xl:grid-cols-[minmax(0,1fr)_380px]">
          <SettingsForm
            settings={settings}
            galleries={galleries}
            loading={loading}
            saving={saving}
            demoMode={demoMode}
            onChange={handleChange}
            onFieldChange={updateField}
            onSubmit={handleSubmit}
          />

          <aside className="hidden xl:block">
            <SettingsPreviewPanel settings={settings} galleries={galleries} />
          </aside>
        </div>
      </div>

      <ToastContainer position="top-right" autoClose={2500} theme="colored" />
    </section>
  );
}